import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

/*
 * Today's sales window. The entire business runs in CST, so we read "now" explicitly in that zone: a
 * bare dayjs() uses the expert's own browser timezone and, near midnight, lands on the wrong day.
 * end=tomorrow 00:00:00 so the backend's date-truncate + 6h business-day window covers all of today.
 */
export const getTodayTimeframe = () => {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const nowCentral = dayjs().tz("America/Chicago");
    return {
        start: nowCentral.format("MM-DD-YYYY").concat(" 00:00:00"),
        end: nowCentral.add(1, "day").format("MM-DD-YYYY").concat(" 00:00:00"),
    };
};
